export default{
    newsFourTitle: "Mampu Percepat Penyaluran Kredit, Ini 4 Kelebihan dari Credit Scoring",
    newsFourTime: "Tanggal Publis",
    newsFourRead:"Tampilan Halaman",
    newsFourSource:"Sumber artikel:",
    newsFourDetail:[
        {
            p:"Rafki Fachrizal - Rabu, 6 Januari 2021 | 12:30 WIB"
        },
        {
            p:"Akibat pandemi COVID-19 yang masih terjadi hingga saat ini, tercatat selama tahun 2020 penyaluran kredit di Indonesia mengalami perlambatan. "
        },
        {
            p:"Selain dikarenakan pandemi yang membuat tekanan ekonomi, kesenjangan (gap) antara kebutuhan kredit masyarakat dan penyaluran dana dari institusi keuangan juga menjadi isu yang krusial."
        },
        {
            p:"Bagi institusi keaungan sendiri, salah satu tantangan terbesar dalam penyaluran kredit adalah terbatasnya riwayat kredit individu."
        },
        {
            p:"Misalnya, pemilik usaha informal yang tidak memiliki pembukuan, atau karyawan muda yang baru memulai karirnya sehingga sulit mendapatkan kredit dari lembaga pembiayaan konvensional. "
        },
        {
            p:"Salah satu yang menjadi kunci dalam menjembatani kredit gap di Indonesia hingga mampu mempercepat penyaluran kredit adalah dengan mengembangkan teknologi penilaian credit scoring (skor kredit) melalui inovasi dan peningkatan variasi data penilaian."
        },

        {
            p:"Saat ini, teknologi skor kredit sendiri telah banyak diterapkan oleh banyak perusahaan fintech (financial technology) dalam menghadirkan layanan kreditnya"
        },
        {
            p:"Teknologi skor kredit mampu menganalisa profil calon peminjam secara lebih cepat, efisien, komprehensif, dan mengurangi kebiasan data."
        },
        {
            p:'Paramananda Setyawan, Chief Data Officer Kredivo, mengatakan, "Adopsi machine learning menggunakan kombinasi data tradisional dan data alternatif memungkinkan fintech menganalisis skor kredit pengguna dengan metrik setaraf bank, dalam waktu yang lebih cepat dan efisien. Alternatif ini dapat menjadi salah satu solusi untuk menjawab tantangan gap kredit di Indonesia."'
        },
        {
            p:"Dilanjutkan Paramananda, hingga kini teknologi skor kredit Kredivo telah menilai kelayakan kredit lebih dari 500 ribu pengguna tiap bulannya serta mampu menyalurkan kredit bagi lebih dari 2 juta pengguna atau 25% dari basis pengguna kartu kredit saat ini."
        },
        {
            p:'"Lebih dari 60% dari total pengguna tersebut mendapatkan akses kredit pertamanya melalui Kredivo," cetus Paramananda.'
        },
        {
            p:'Lebih lanjut, setidaknya terdapat 4 kelebihan inovasi credit scoring dibandingkan dengan metode analisa kredit yang konservatif, di antaranya:'
        },
        {
            h4:'1. Meningkatkan kualitas penilaian kelayakan kredit'
        },
        {
            p:'Masyarakat yang memiliki skor kredit rendah tentu sulit untuk mendapatkan kredit. Inovasi skor kredit memungkinkan kreditur dapat menentukan kemampuan calon debitur dengan menganalisa data alternatif lain seperti perilaku saat mendaftar dan pola pembelanjaan.'
        },
        {
            p:'"Berbagai sumber data alternatif yang digunakan untuk proses penilaian tersebut membantu kami menghasilkan analisis yang cepat dan lebih akurat, yang tentunya tetap mengutamakan perlindungan privasi pengguna sesuai dengan ketentuan regulator saat ini, yaitu pembatasan data digital yang bisa diakses dari smartphone hanya melalui kamera, mikrofon, dan lokasi," tambah Paramananda.'
        },
        {
            h4:'2. Memperluas akses kredit dan mempercepat penyerapan kredit'
        },
        {
            p:'Masyarakat seperti pekerja pemula dengan riwayat kredit terbatas dan para pengusaha pemula merupakan kalangan masyarakat yang masih sulit mendapatkan akses kredit secara konvensional.'
        },
        {
            p:'Melalui inovasi skor kredit, mereka memiliki kesempatan untuk mengakses kredit secara cepat dan mudah.'
        },
        {
            p:'Bahkan jika analisa yang dilakukan dari berbagai data alternatif menunjukkan hasil yang baik, mereka akan mendapatkan skor kredit yang tinggi dan memperoleh pinjaman dengan nominal yang besar.'
        },
        {
            p:'Selain itu, inovasi skor kredit juga memungkinkan penyerapan kredit secara lebih cepat, khususnya bagi pelaku UMKM.'
        },
        {
            h4:'3. Penyajian data yang lebih akurat dan real-time'
        },
        {
            p:'Pada proses skor kredit konservatif, riwayat kredit calon debitur yang buruk akan memengaruhi hasil analisa, setidaknya selama 1-2 tahun setelah proses kredit tersebut terjadi.'
        },
        {
            p:'Calon debitur akan membutuhkan waktu cukup lama untuk kembali memulihkan riwayat kredit dan memperoleh skor kredit yang baik.'
        },
        {
            p:'Sehingga jika calon debitur mengalami gagal bayar pada 2 tahun yang lalu, ia masih dianggap sebagai profil yang berpotensi berisiko saat ini meskipun kondisi keuangannya telah meningkat pesat dalam 2 tahun terakhir tersebut.'
        },
        {
            p:'Namun, berbagai data alternatif yang digunakan dalam analisa skor kredit inovatif merupakan data real-time sehingga mampu menjadi solusi bagi mereka yang pernah mengalami gagal bayar.'
        },
        {
            h4:'4. Mengurangi bias informasi'
        },
        {
            p:'Inovasi yang didesain oleh fintech telah memberikan dampak besar pada tingkat inklusi keuangan di berbagai negara.'
        },
        {
            p:'Fintech memanfaatkan teknologi dan alat digital yang diautomasi untuk mengurangi bias karena faktor - faktor human error.'
        },
        {
            p:'Algoritme yang digunakan fintech mampu memberikan hasil analisa yang akurat sesuai dengan profil risiko pengguna.'
        },
    ]
}